import React from 'react'
import styles from '../../styles/home.module.css';
import { IMAGEPATH } from '../../constants/imagePath';
import { KR } from '../../constants/localizations';

export default function HomeMainSection() {
    return (
        <div className={styles.home}>
            <img src={IMAGEPATH.main} srcSet={IMAGEPATH.mainWebp} alt="main_image" />
            <div className={styles.titleWrap}>
                <div className={styles.title}>
                    <div>
                        <h1>{KR.label_home_logo}</h1>
                        <span className={styles.divideM}></span>
                        <span>{KR.label_home_subTitle_a}{KR.label_home_subTitle_b}</span>
                    </div>
                    <span className={styles.divide}></span>
                    <div>
                        <p>
                            에이알247(주)는 배달 로봇과 물류 로봇 분야의 선두주자로서<br />
                            <span>
                                완전 무인 자율주행 기술을 통해 물류 산업의 새로운 패러다임
                            </span>
                            을,
                            <br />
                            빠르고 안전한 서비스로 일상과 산업에 새로운 변화를 선사합니다.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}        
